<template>
  <div class="flex w-full">
    <div
      v-if="isDepositoJudicial"
      class="w-full flex flex-column align-items-end justify-content-center px-3 py-0 m-0"
    >
      <DashboardJudicial />
    </div>

    <div class="page w-full" v-else-if="!showOldView">
      <div class="dropdown-space" v-if="showDropdown">
        <Dropdown
          v-model="dependenciaDrop"
          :options="dependenciaList"
          filter
          optionLabel="dependencia"
          optionValue="id"
          placeholder="Seleccione una dependencia..."
          showClear
        />
      </div>
      <div class="upContainer">
        <DashboardTopInfo v-if="!isDepositoJudicial && offline" :dependencia="dependenciaDrop" />
      </div>
      <div class="downContainer" :class="{ centered: isDepositoJudicial }">
        <div class="center" v-if="!isDepositoJudicial">
          <DashboardChart :dependencia="dependenciaDrop" />
        </div>
      </div>
      <br />
      <div v-if="!isDepositoJudicial && offline">
        <DashboardBottomInfo :dependencia="dependenciaDrop" :user="usuario" />
      </div>
    </div>

    <div
      v-else
      class="w-full flex flex-column align-items-end justify-content-center px-3 py-0 m-0"
    >
      <DashboardUFIS />
    </div>

    <ConfirmPopup group="demo" ref="ConfirmPopup" style="z-index: 999" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useRouterCompat } from "@/composables/useRouterCompat.js";
import { useUserAccess } from "@/composables/useUserAccess.js";
import { useProsecutor } from "@/composables/DenunciaFormDatosGenerales/useProsecutor";
import { useOfflineCompat } from "@/composables/useOfflineCompat";
import DashboardTopInfo from "@/components/Dashboard/DashboardTopInfo";
import DashboardBottomInfo from "./DashboardBottomInfo.vue";
import DashboardChart from "@/components/Dashboard/DashboardChart";
import DashboardJudicial from "../Escritorios/DashboardJudicial.vue";
import DashboardUFIS from "../Escritorios/DashboardUFIS.vue";

const store = useStoreCompat();
const { router } = useRouterCompat();
const { esTipoUsuario } = useUserAccess();
const { prosecutorUserTypes } = useProsecutor();
const offline = useOfflineCompat();

const dependenciaDrop = ref(null);
const usuario = computed(() => store.state.user);
const ConfirmPopup = ref(null);

const dependenciaList = computed(() => store.getters["siis/getDependecias"]);

const showDropdown = computed(() => {
  const types = [
    "Super User",
    "User Tester",
    "Super Usuario de E3",
    "Dpto. Asuntos Judiciales D-5",
    "Dpto.Criminalistica",
    "Lab. Informatico Forense",
    "Control de Gestion",
    "Direcci贸n de Informaci贸n para el Delito D-2",
    "Dpto. Planeamiento",
    "UsuarioDepartamental",
    ...prosecutorUserTypes.value,
  ];
  return esTipoUsuario(types, usuario.value);
});

const isDepositoJudicial = computed(() => {
  return esTipoUsuario(["Deposito Judicial"], usuario.value);
});

const showOldView = computed(() => {
  return esTipoUsuario(
    [
      "Super User",
      "UsuarioDepartamental",
      "Jefe de Dependencia",
      "Jefe de Sumario",
      "Oficial Sumariante",
      "Direcci贸n de Informaci贸n para el Delito D-2",
      "Dpto. Asuntos Judiciales D-5",
      "Dpto. Planeamiento",
      "Dpto.Criminalistica",
      "Lab. Informatico Forense",
      "Control de Gestion",
      "Juez",
      "Ayudante de Juez",
      "Ayudante Fiscal",
      "Fiscal",
      "Fiscal General",
      "Policia Investigador",
      "Supervisor",
      "Administrativo",
    ],
    usuario.value
  );
});

onMounted(async () => {
  if (usuario.value.userdata.tipoUsuario === "Notificante") {
    router.push({ path: "/notificaciones" });
    return;
  }
  if (usuario.value.userdata.tipoUsuario === "Calabocero") {
    router.push({ path: "/calabozo" });
    return;
  }

  if (
    esTipoUsuario(["Jefe de Dependencia", "Jefe de Sumario", "Oficial Sumariante"], usuario.value)
  ) {
    dependenciaDrop.value = usuario.value.userdata.dependenciaID;
  }

  await store.dispatch("siis/setMarca");
  await store.dispatch("siis/setModelo");
  await store.dispatch("siis/setCategoriasDeposito");
  await store.dispatch("siis/setSubCategoriasDeposito");
  await store.dispatch("siis/setTipoDeposito");
  await store.dispatch("siis/setEstadosEfectoDeposito");
  await store.dispatch("siis/setEstadosSolicitudDeposito");
  await store.dispatch("siis/setDependencias");
});
</script>
<style scoped>
.left-column {
  display: flex;
  gap: 4rem;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 600px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 2.87rem;
}

.right-column {
  min-width: 500px;
}

.dropdown-wrapper {
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.topWrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: start;
  font-family: "IBM Plex Sans", sans-serif;
  margin-top: 20px;
}
.topWrapper h1 {
  font-weight: 700;
  margin: 0;
}

.custom-focus:focus-within {
  border: 1.5px solid #3758f9;
}
.custom-focus {
  font-family: "IBM Plex Sans", sans-serif;
}

.dropdown-space {
  margin-bottom: 20px;
}

.upContainer {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.downContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}

.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}

.centered-biblioteca {
  width: 100%;
  max-width: 800px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}
</style>
